import { render, staticRenderFns } from "./formModal.vue?vue&type=template&id=28d11fb4&scoped=true&"
import script from "./formModal.vue?vue&type=script&lang=js&"
export * from "./formModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d11fb4",
  null
  
)

export default component.exports